import React, { useContext, useEffect, useState, useRef } from 'react';
import { AuthContext } from '../AuthContext';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import { site_url, truck, site_url_img } from "../config.js";
import { Formik } from 'formik';
import axios from 'axios';
import { IndianCurrencyFormatter, FormatDate } from '../Function';
import { useQuery } from '@tanstack/react-query';
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import './styles.css';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';

const ProductBilling = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(useLocation().search);
  const id = queryParams.get('id');

  const [products, setproducts] = useState([]);
  const inputRef = useRef(null);
  const inputRefqty = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [billItems, setBillItems] = useState([]);
  const [gsttype, setgsttype] = useState('without_gst');
  const [pricetype, setpricetype] = useState(1);
  const [sales_payment_type, setsales_payment_type] = useState('credit');
  const [paidamount, setpaidamount] = useState(0);

  const [maindetails, setmaindetails] = useState([]);

  const [paymentid, setpaymentid] = useState('');


  const [product_cates, setproduct_cates] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({
    id:'all',
    'label':'all'
  });

  const [shopsub_cates, setshopsub_cates] = useState([]);
  const [selectedsubcategory, setselectedsubcategory] = useState({
    id:'all',
    'label':'all'
  });

  
  
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const routepath = async () => {
    console.log(selectedCategory);
    try {
      const response = await axios.get(`${site_url}/listofproduct_ex_api/${pricetype}/${selectedCategory.id}/${selectedsubcategory.id}/${id}?_=${Date.now()}`,{
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      });
      if (response.data.status == 'success') {
        console.log(response.data);
        setproducts(response.data.routes);
      }

    } catch (error) {

    }
  }
  const productcates = async () => {
    try {
      const response = await axios.get(site_url + '/product_cates');
      if (response.data.status == 'success') {
    
       
        setproduct_cates(response.data.product_cate);
      }

    } catch (error) {

    }
  }

  const shop_sub_cates = async () => {
    try {
      const response = await axios.get(site_url + '/shop_sub_cates');
      if (response.data.status == 'success') {
        console.log(response.data);

        const allOption = { id: 'all', label: 'all' };
        const updatedData = [allOption, ...response.data.product_cate];
        setshopsub_cates(updatedData);

      }

    } catch (error) {

    }
  }


  const getexitdetails = async () => {
    try {
      const response = await axios.get(site_url + '/edit_billdetails/'+id);
      if (response.data.status == 'success') {
    console.log(response.data.order);
       
        setBillItems(response.data.order);
        setmaindetails(response.data.mainorder);
        setpricetype(response.data.mainorder.price_type);
        setgsttype(response.data.mainorder.billtype);
        setpaidamount(response.data.sales_pay.sales_amount);
        setpaymentid(response.data.sales_pay.sales_pay_id);
      }

    } catch (error) {

    }
  }



  useEffect(() => {

    routepath();
    productcates();
  }, [])

  useEffect(() => {

    routepath();
    shop_sub_cates();
  }, [pricetype,product_cates])


  useEffect(() => {

getexitdetails()
  }, [])

  

  useEffect(() => {
  shop_sub_cates();
  routepath();
  }, [selectedsubcategory])

  const billsubmit = async () => {
    try {
      console.log(paidamount);
      if (isNaN(paidamount) || paidamount === '') {
        alert('Please enter a valid amount');
        return;
    }
    
      const data = {
        billItems: billItems,
        shopid: maindetails.shop_id,
        userid: maindetails.work_id,
        sales_payment_type: maindetails.sales_payment_type,
        paidamount:paidamount,
        pricetype:pricetype,
        gsttype:gsttype,
        mainordersid:id,
        sales_pay_id:paymentid
      }

      const response = await axios.post(site_url + '/editbillorder', data);
      console.log(response.data);
      if (response.data.status == 'success') {
        Swal.fire({
          title: 'Success!',
          text: 'Order placed successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/Transaction'); // Replace with your desired route
          }
        });
        
      }

    } catch (error) {

    }
  }

  const showSuccessAlert = () => {

    Swal.fire({
      title: "Do you want to save the changes?",
      confirmButtonText: "Save",
      showCancelButton: true,


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        billsubmit();
      }
    });
  };

  const customFilter = (option, inputValue) => {
    // Search using the English value
    return option.value.toLowerCase().includes(inputValue.toLowerCase());
  };
  const handleProductChange = (selected) => {
    console.log(selected);
    setSelectedProduct(selected);
    setQuantity('');
    setTimeout(() => {
      if (inputRefqty.current) {
        inputRefqty.current.focus();
      }
    }, 100);
  };

  
  const handleAddToBill = () => {
    if(quantity == ''){
      return;
    }
    if (!selectedProduct || quantity < 0) return;
  
    const isExisting = billItems.some(item => item.id === selectedProduct.id);
  
    if (isExisting) {
      const confirmAdd = window.confirm("This product already exists in the bill. Do you want to add the quantity?");
      if (!confirmAdd) {
        setSelectedProduct(null);
        setQuantity(1);
        inputRef.current?.focus();
        return;
      }
  
      // Update existing item
      const updated = billItems.map(item =>
        item.id === selectedProduct.id
          ? {
              ...item,
              qty: item.qty + quantity,
                subtotal: parseFloat(((item.qty + quantity) * item.price).toFixed(2)),
            }
          : item
      );
  
      setBillItems(updated);
    } else {
      // Add new item
      setBillItems([
        ...billItems,
        {
          id: selectedProduct.id,
          name: selectedProduct.label,
          product_image: selectedProduct.product_image,
          price: selectedProduct.price,
          qty: quantity,
          subtotal: parseFloat((selectedProduct.price * quantity).toFixed(2)),
          od_product_gst: selectedProduct.od_product_gst,
          od_prod_gname: selectedProduct.od_prod_gname,
          od_prod_gid: selectedProduct.od_prod_gid,
        },
      ]);
    }
  
    setSelectedProduct(null);
    setQuantity(1);
    inputRef.current?.focus();
  };

  const handleQtyChange = (id, newQty) => {
    if (newQty < 1) return; // Prevent 0 or negative qty

    setBillItems((prevBill) =>
      prevBill.map((item) =>
        item.id === id
          ? { ...item, qty: newQty, subtotal: parseFloat((newQty * item.price).toFixed(2)) }
          : item
      )
    );
  };

  const handleRemoveItem = (id) => {
    setBillItems((prevBill) => prevBill.filter((item) => item.id !== id));
  };

  const getGrandTotal = () =>
    billItems.reduce((total, item) => total + item.subtotal, 0);

  return (
    <div className=" max-w-xl mx-auto">
      <div className='p-4'>
        <h2 className="text-lg font-bold mb-2">Product Billing</h2>

        <div class="form-group col-md-2" style={{display:'none'}}>
          <label for="exampleFormControlInput1">Bill Type</label>

          <select value={gsttype}
            onChange={(e) => setgsttype(e.target.value)} id="gstOption" name="billtype" class="form-select">
            <option value="without_gst" selected="">Without GST</option>
            <option value="with_gst">With GST</option>
          </select>
        </div>
        <div class="form-group col-md-2">

          <label for="exampleFormControlSelect1">Price Type</label>
          <select value={pricetype}
            onChange={(e) => setpricetype(e.target.value)}
            name="price_type" class="form-control" id="price_type">
            <option selected="" value="1">Whole-Sale Price</option>

            <option value="0">Retail Price</option>

          </select>

        </div>
        <div style={{display:'none'}}>
        <Select
    
          options={product_cates}
          value={selectedCategory}
          onChange={(e)=> setSelectedCategory(e)}
          placeholder="Select a Category..."
         
        />
</div>
<br></br>
<Select
          options={shopsub_cates}
          value={selectedsubcategory}
          onChange={(e)=> setselectedsubcategory(e)}
          placeholder="Select a Sub Category..."
         
        /><br></br>
        <Select
          options={products}
          value={selectedProduct}
          onChange={handleProductChange}
          placeholder="Select a product..."
          filterOption={customFilter}
          ref={inputRef}
        />

        {/* Price & Quantity Input */}
        {selectedProduct && (
          <div className="mt-3">
            <p className="text-gray-700 pricetext">Price: Rs.<IndianCurrencyFormatter amount={selectedProduct.price} /></p>
            <input
              type="number"
              min="0"
              step="0.01"
              value={quantity}
              onChange={(e) => setQuantity(parseFloat(e.target.value))}
              className="border rounded p-1 w-20"
              ref={inputRefqty}
            />&nbsp;&nbsp;&nbsp;
            <button
              onClick={handleAddToBill}
              className="bg-blue-500 text-white px-3 py-1 ml-3 rounded btn btn-primary"
            >
              Add to Bill
            </button>
          </div>
        )}
      </div>
      {/* Bill Table */}
      {billItems.length > 0 && (
        <div className="mt-2 table-responsive" style={{marginBottom:'30%'}}>
          <table className="border-collapse border border-gray-300 table ">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Product</th>
                <th className="border p-2">Price</th>
                <th className="border p-2">Qty</th>
                <th className="border p-2">Subtotal</th>
                <th className="border p-2">Action</th>
              </tr>
            </thead>
            <tbody>
            {[...billItems].reverse().map((item) => (
                <tr key={item.id} className="text-center">
                  <td className="border p-2 ">
                    {item.product_image != '' ? (
                      <img src={site_url_img + '/' + item.product_image} className="producimg" />
                    ) : (
                      <img
                        src={truck}
                        alt="img"
                        className="producimg"
                      />
                    )}
                    <span className='productname'>{item.name}</span></td>
                  <td className="border p-2"><b className='boldcolor'><IndianCurrencyFormatter amount={item.price} /></b></td>
                  <td className="border p-2">
                    <input
                      type="number"
                      min="1"
                      value={item.qty}
                      step="0.01"
                      onChange={(e) => handleQtyChange(item.id, parseFloat(e.target.value))}
                      className="border rounded p-1 w-16 text-center qty_text"
                    />
                  </td>
                  <td className="border p-2"><b className='boldcolor'><IndianCurrencyFormatter amount={item.subtotal} /></b></td>
                  <td className="border p-2">
                    <button
                      onClick={() => handleRemoveItem(item.id)}
                      className="bg-red-500 text-white px-2 py-1 rounded btn btn-success"
                    >
                      ❌
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Grand Total */}
          <h3 className="mt-3 text-lg font-bold text-center">
            Total Product :{(billItems.length > 0 && billItems.length)}
          </h3>
          <h3 className="mt-3 text-lg font-bold text-center">
            Grand Total: <IndianCurrencyFormatter amount={getGrandTotal()} />
          </h3>
          <div class="form-group " style={{display:'none'}}>
          <h6 class="mt-4">Payment Mode</h6>
                        <select value={sales_payment_type}
            onChange={(e) => setsales_payment_type(e.target.value)} 
             id="paymentMode" name="payment_type" class="form-select" required="">
                            <option value="cash">Cash</option>
                            <option value="bank">Bank</option>
                            <option  value="credit">Credit</option>
                        </select>
                        </div>
                        <div class="form-group " style={{display:'none'}}>
                        <h6 class="mt-4">Paid Amount</h6>
                        <input
                      type="number"
                      min="1"
                      step="0.01"
                      value={paidamount}
                      onChange={(e) => setpaidamount(parseFloat(e.target.value))}
                      className="border rounded p-1 w-16 text-center qty_text"
                    />   
                  </div>



          <center>
            <button className='btn btn-danger' onClick={showSuccessAlert}>Bill Save</button>

          </center>
        </div>
      )}
      <Sidebar />
      <Footer />
    </div>
  );
};

export default ProductBilling;
